import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout, currentUser } = useAuth();

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const handleLogoClick = (e) => {
        e.preventDefault();
        window.location.href = window.location.pathname;
    };

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <a href={window.location.pathname} onClick={handleLogoClick} style={{ textDecoration: 'none' }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div style={{
                            fontSize: '28px',
                            fontWeight: '900',
                            color: '#12a046',
                            letterSpacing: '-1px',
                            marginBottom: '-4px'
                        }}>
                            Otyma<span style={{ color: '#fff' }}>Farma</span>
                        </div>
                        <div style={{
                            fontSize: '10px',
                            fontWeight: '700',
                            color: 'rgba(255,255,255,0.4)',
                            textTransform: 'uppercase',
                            letterSpacing: '2px'
                        }}>
                            Administrativo
                        </div>
                    </div>
                </a>
            </div>
            <ul className="sidebar-menu">
                <li className={isActive('/dashboard')}>
                    <Link to="/dashboard">
                        <i className="fas fa-home"></i> Dashboard
                    </Link>
                </li>
                <li className={isActive('/produtos')}>
                    <Link to="/produtos">
                        <i className="fas fa-shopping-cart"></i> Produtos
                    </Link>
                </li>
                <li className={isActive('/categorias')}>
                    <Link to="/categorias">
                        <i className="fas fa-tags"></i> Categorias
                    </Link>
                </li>
                <li className={isActive('/whatsapp')}>
                    <Link to="/whatsapp">
                        <i className="fab fa-whatsapp"></i> WhatsApp
                    </Link>
                </li>
                <li className={isActive('/affiliates')}>
                    <Link to="/affiliates">
                        <i className="fas fa-handshake"></i> Afiliados
                    </Link>
                </li>
                <li className={isActive('/banners')}>
                    <Link to="/banners">
                        <i className="fas fa-images"></i> Gerenciar Banners
                    </Link>
                </li>
                <li className={isActive('/lojas')}>
                    <Link to="/lojas">
                        <i className="fas fa-store"></i> Gerenciar Lojas
                    </Link>
                </li>
                <li className={isActive('/blog')}>
                    <Link to="/blog">
                        <i className="fas fa-edit"></i> Blog/Conteúdo
                    </Link>
                </li>
                <li className={isActive('/comentarios')}>
                    <Link to="/comentarios">
                        <i className="fas fa-comments"></i> Comentários
                    </Link>
                </li>
                <li className={isActive('/validacao-notas')}>
                    <Link to="/validacao-notas">
                        <i className="fas fa-receipt"></i> Validação de Notas
                    </Link>
                </li>
                <li className={isActive('/resgates')}>
                    <Link to="/resgates">
                        <i className="fas fa-gift"></i> Solicitações de Resgate
                    </Link>
                </li>
                <li className={isActive('/usuarios')}>
                    <Link to="/usuarios">
                        <i className="fas fa-users"></i> Usuários
                    </Link>
                </li>
            </ul>
            <div className="sidebar-footer">
                {currentUser && (
                    <div style={{
                        padding: '16px',
                        marginBottom: '12px',
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        border: '1px solid rgba(255, 255, 255, 0.05)'
                    }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            backgroundColor: 'var(--primary-color)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '18px'
                        }}>
                            <i className="fas fa-user-shield"></i>
                        </div>
                        <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', fontWeight: '600', textTransform: 'uppercase' }}>Admin</span>
                            <span style={{
                                fontWeight: '600',
                                fontSize: '13px',
                                color: '#fff',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {currentUser.email.split('@')[0]}
                            </span>
                        </div>
                    </div>
                )}
                <button onClick={handleLogout} className="logout-link" style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <i className="fas fa-sign-out-alt"></i> Sair do Painel
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
